export default __webpack_public_path__ + "images/sweep5.e5972aac8c27b6d2acc93adc52459e67.gif";